"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _DEKAT4J4cjs = require('../__chunks/DEKAT4J4.cjs');


var _6E4BBKC4cjs = require('../__chunks/6E4BBKC4.cjs');
require('../__chunks/2XVCJUVB.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/MWXEIKZX.cjs');
require('../__chunks/T3QB4FR3.cjs');


var _FH6HQ5JNcjs = require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');


var _3BSDKDKDcjs = require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/tab/tab-list.tsx
var _misc = require('@ariakit/core/utils/misc');
var _jsxruntime = require('react/jsx-runtime');
var TagName = "div";
var useTabList = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useTabList2({ store, ...props }) {
    const context = _DEKAT4J4cjs.useTabProviderContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "TabList must receive a `store` prop or be wrapped in a TabProvider component."
    );
    const orientation = _FH6HQ5JNcjs.useStoreState.call(void 0, 
      store,
      (state) => state.orientation === "both" ? void 0 : state.orientation
    );
    props = _3BSDKDKDcjs.useWrapElement.call(void 0, 
      props,
      (element) => /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _DEKAT4J4cjs.TabScopedContextProvider, { value: store, children: element }),
      [store]
    );
    if (store.composite) {
      props = {
        focusable: false,
        ...props
      };
    }
    props = {
      role: "tablist",
      "aria-orientation": orientation,
      ...props
    };
    props = _6E4BBKC4cjs.useComposite.call(void 0, { store, ...props });
    return props;
  }
);
var TabList = _PTOCUU2Dcjs.forwardRef.call(void 0, function TabList2(props) {
  const htmlProps = useTabList(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.TabList = TabList; exports.useTabList = useTabList;
